import UpiContextProvider from '@providers/UpiContextProvider';
import {Query} from 'react-apollo';
import {client} from '@core/GraphQLProvider';
import {GetCustomer} from '@services/Customer/query.graphql';
import {ProductOfferingRenderer} from '@containers/FindADentistOptIn/renderer';

const FindADentist = () =>
    <UpiContextProvider>
        <Query client={client}
               fetchPolicy="cache-first"
               query={GetCustomer}
               variables={{
                   withProductOfferingLocations: true
               }}>
            {ProductOfferingRenderer()}
        </Query>
    </UpiContextProvider>

export default FindADentist; 
